import * as React from "react";
export interface IInputProps {
  id: string;
  data: string;
  setData: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  placeholder: string;
  type?: string;
  error?: string | any;
}

export default function Input({
  id,
  data,
  setData,
  placeholder,
  type = "text",
  error,
}: IInputProps) {
  return (
    <div className="form-input relative flex-1 w-full">
      <input
        id={id}
        name={id}
        type={type}
        placeholder={placeholder}
        value={data}
        onChange={setData}
        className="text-white bg-black input-form focus:border-primary border-l-0 border-r-0 bg-transparent border-b border-bordermood w-full  outline-none px-3 py-2 rounded-md text-sm"
      />
      <span className="text-red-500 text-sm font-normal"> {error || ""}</span>
    </div>
    //
  );
}
